module.exports = __webpack_public_path__ + "img/down_arrow.17599906.svg";